export default "__VITE_ASSET__rpPjwx$0__"